import {AfterViewInit, Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-real-time-service-levels-popup',
    templateUrl: './real-time-service-levels-popup.component.html',
    styleUrls: ['./real-time-service-levels-popup.component.scss', '../real-time-popup/real-time-popup.component.scss']
})
export class RealTimeServiceLevelsPopupComponent {
    properties = null;

    constructor(
        private translateService: TranslateService
    ) {
    }

    getTranslation(key) {
        return this.translateService.instant(key);
    }

}



// WEBPACK FOOTER //
// ./src/app/real-time/real-time/real-time-service-levels-popup/real-time-service-levels-popup.component.ts